import { render, staticRenderFns } from "./TraingaiqiantuipiaoRight.vue?vue&type=template&id=b0b56fde&scoped=true"
import script from "./TraingaiqiantuipiaoRight.vue?vue&type=script&lang=js"
export * from "./TraingaiqiantuipiaoRight.vue?vue&type=script&lang=js"
import style0 from "./TraingaiqiantuipiaoRight.vue?vue&type=style&index=0&id=b0b56fde&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b0b56fde",
  null
  
)

export default component.exports